module.exports = __webpack_public_path__ + "img/ojo.53bf759d.png";